/* eslint-disable react/prop-types */
import React from "react"
import Footer from "../Footer"
import { Header } from "../Header"
import { Grid, Box } from "@material-ui/core"
// import logo from "assets/img/logo.png"

const TextPage = (props) => {
  const { pageTitle, pageContent } = props

  return (
    <>
      <Grid container className="container">
        <Header title={pageTitle} />

        <Grid container>
          <Grid item xs={12}>
            <Box mt={2} p={1}>
              {pageContent}
              {/* <Link href="/add-accomodation">
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                  // startIcon={<LeaveReviewIcon />}
                >
                  Aggiungi la tua struttura
                </Button>
              </Link> */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Footer />
    </>
  )
}

export default TextPage
